<template>
    <div class="home">
        <ddHead :title="titleName"></ddHead>
        <img class="profile_bg" :src="info.bg_url" alt="">
        <div class="profile" :class="{profile_nobg:isHaveBg}">
            <div class="headimg">
                <img :src="info.face_img" alt="">
            </div>
            <div class="user_name">
                <div>
                    <span>{{info.nickname || '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'}}</span>
                    <img class="user_link user_home" v-if="info.customer_identity_url" v-lazy="info.customer_identity_url" alt="">

                    <img :src="info.gender!=0?'./images/female.png':'./images/male.png'" alt="">
                </div>
    
            </div>
            <div class="follow">
                <router-link to="myfollow" class="follow_link" dd_name="关注人数">关注&nbsp{{followInfo.data.follow_count || 0}}&nbsp</router-link>
                <span></span>
                <router-link to="myfans" class="follow_link" dd_name="粉丝人数">&nbsp粉丝&nbsp{{followInfo.data.fans_count || 0}}</router-link>
            </div>
            <div class="introduce">
                <p :class="{omit:isOmit,textLeft:isTextLeft}" @click="openDesc">简介：{{info.desc || '这位书友正在书海畅游，还没有编辑个人介绍。'}} </p>
    
            </div>
    
            <router-link :to="{name:'edit',params:{item:info}}" class="edit" v-if="is_self" dd_name="编辑">
                <div class="edit_icon"></div>
                编辑个人资料
            </router-link>
        </div>
        <div class="follow_button" @click="followMe" v-if="is_focus" dd_name="关注">
            <div class="no_concern" v-if="!isFollow">
                <img src="../assets/images/follow.png" alt="">
                <span>关注</span>
            </div>
            <div class="aleady_concernd" v-else>已关注</div>
        </div>
        <ul class="contact" v-if="info.show==='enabled'">
    
            <li v-if="info.qq">
                <div class="qq_bg"></div>
                <p class="omit">{{info.qq}}</p>
            </li>
            <li v-if="info.weixin">
                <div class="wechat_bg"></div>
                <p class="omit">{{info.weixin}}</p>
            </li>
            <li v-if="info.email">
                <div class="email_bg"></div>
                <p class="omit">{{info.email}}</p>
            </li>
        </ul>
        <!-- 我要出书-开始 -->
        <div class="book_info">
            <p class='title'>我要出书</p>
            <div class="book_info_contain" v-if="isHaveBookInfo">
                <bookinfo-item :content="item" :is_self="is_self" v-for="item in bookInfoList" :key="item.bookId"></bookinfo-item>
            </div>
            <div class="book_info_btn">

                <template v-if="is_self">
                    <a :href=" myBookListUrl "  class="info_btn" v-if="is_self" dd_name=" isHaveBookInfo? '全部作品' : '我关注的作品' ">{{isHaveBookInfo? '全部作品' : '我关注的作品' }}</a>

                    <!-- <router-link :to="{name:'edit',params:{}}" class="info_btn" v-if="is_self" dd_name="谈交易记录">谈交易记录</router-link> -->
                </template>

                <template v-if="!is_self">
                    <a :href=" myBookListUrl " class="info_btn" v-if="is_self" dd_name=" isHaveBookInfo? '全部作品' : '看看Ta关注的作品' ">{{isHaveBookInfo? '全部作品' : '看看Ta关注的作品' }}</a>
                </template>
                
            </div>
        </div>
        <!-- 我要出书-结束 -->
        <div class="book_comment">
            <h2>短书评（{{commentList.totalNum || 0}}）</h2>
            <div class="book_comment_contain" v-if="!isHaveBookComment">
                <book-comment :content="item" v-for="item in commentList.data" :key="item.id" :comment-type="0"></book-comment>
                <router-link :to="{name:'bookcommentList',params:{comment_type:0}}" class="book_comment_button" v-if="commentList.totalNum > 3" dd_name="全部短书评"> 全部短书评{{commentList.totalNum}}条</router-link>
            </div>
            <div class="no_comment" v-if="isHaveBookComment">{{isHaveBookComment}}</div>
        </div>
        <div class="book_comment">
            <h2>长书评（{{commentLongList.totalNum || 0}}）</h2>
            <div class="book_comment_contain" v-if="!isHaveLongBookComment">
                <book-comment :content="item" v-for="item in commentLongList.data" :key="item.id" :comment-type="1"></book-comment>
                <router-link :to="{name:'bookcommentList',params:{comment_type:1}}" class="book_comment_button" v-if="commentLongList.totalNum > 3" dd_name="全部长书评"> 全部长书评{{commentLongList.totalNum}}条</router-link>
            </div>
            <div class="no_comment" v-if="isHaveLongBookComment">{{isHaveLongBookComment}}</div>
        </div>
        <div class="book_list">
            <h2>书单（{{bookList.pageInfo.total || 0}}）</h2>
            <div class="book_list_contain" v-if="!isHaveBookList">
                <booklist-item :conent="item" v-for="item in bookList.result" :key="item.id"></booklist-item>
    
                <router-link to="bookList" class="book_comment_button" v-if="bookList.pageInfo.total>3" dd_name="全部书单"> 全部书单{{bookList.pageInfo.total}}个</router-link>
            </div>
            <div class="no_comment" v-if="isHaveBookList">{{isHaveBookList}}</div>
        </div>
        
        <div class="send_email" v-if="isComplete">
            <p>申请成为书评人或者组建书评团</p>
            <p>请联系ddshequ@dangdang.com</p>
        </div>
        <popup :pop-obj="errobj" v-if="errobj.type" @confirm-click="confirmEvent"></popup>
    </div>
</template>
<script>
import ddHead from './header.vue'
import popup from './popup.vue'
import bookinfoItem from './bookInfoItem.vue'//我要出书列表
import bookComment from './bookcomment.vue'
import booklistItem from './booklistItem.vue'
import {is_login} from '../common/js/login.js'

export default {
    name: 'homepage',
    components: { ddHead, popup, bookComment, booklistItem, bookinfoItem },
    data() {
        return {
            titleName: '个人中心',
            bookInfoList:[],//我要出书列表
            myBookListUrl: '',
            isHaveBookInfo: false,
            commentList: {

            },           
            commentLongList:{},
            bookList: {
                pageInfo: ''
            },
            errobj: {
                type: '',
                errorMsg: ''
            },
            isFollow: false,
            info: {
                nickname: ''
            },
            followInfo: {
                data: {}
            },
            is_self: false,
            is_focus: false,
            isHaveBookComment: '',
            isHaveLongBookComment: '',
            isHaveBookList: '',
            isOmit: true,
            isHaveBg: false,
            isTextLeft: false,
            isOpen: false,
            isComplete:false
        }
    },
    methods: {
        followMe() {
            if (!this.isFollow) {
                this.$http({
                    method: 'post',
                    url: 'my.php',
                    data: {
                        action: 'follow'
                    }
                }).then((result) => {
                    var data = result.data;
                    if (data.errorCode == 0) {
                        this.isFollow = true
                        this.followInfo.data.fans_count += 1
                    } else if (data.errorCode == 96) {
                        window.location.href = login_url
                    } else {
                        this.errobj = {
                            type: 'pop',
                            errorMsg: data.errorMsg
                        }
                    }
                }).catch(() => {
                    this.errobj = {
                        type: 'pop',
                        errorMsg: '网络错误请稍后重试'
                    }
                })
            } else {
                this.$store.commit('overFlowHidden')
                this.errobj = {
                    type: 'confirm',
                    errorMsg: '确认取消对该用户的关注？'
                }
            }
        },
        confirmEvent(isConfirm) {
            if (isConfirm) {
                this.$http({
                    method: 'post',
                    url: 'my.php',
                    data: {
                        action: 'un_follow'
                    }
                }).then((result) => {
                    var data = result.data;
                    if (data.errorCode == 0) {
                        this.isFollow = false
                        this.followInfo.data.fans_count -= 1
                    } else {
                        this.errobj = {
                            type: 'pop',
                            errorMsg: data.errorMsg
                        }
                    }
                }).catch(() => {
                    this.errobj = {
                        type: 'pop',
                        errorMsg: '网络错误请稍后重试'
                    }
                })
            }
        },
        openDesc() {
            if (!this.is_self && this.isOpen) {
                // this.isTextLeft = true
                this.isOmit = !this.isOmit
            }
        }
    },
    created() {
        if (process.env.NODE_ENV === 'production') {
            if(!is_login()){
                window.location.href = login_url
            }
        }
        var emptyText = '这位书友还没有发表内容哦。'
        var allEmptyText = {
                isHaveBookComment:emptyText,
                isHaveLongBookComment:emptyText,
                isHaveBookList:emptyText
            }
        //个人信息

        function getInfo(){
            return new Promise((resolve,reject) => {
                this.$http({
                    method: 'post',
                    url: 'my.php',
                    data: {
                        action: 'info'
                    }
                }).then((result) => {
                    var data = result.data;
                    if (data.errorCode == 0) {
                        this.info = data.data;
                        if (!this.info.bg_url) {
                            this.isHaveBg = true
                            this.info.bg_url = ''
                        }
                        this.is_self = data.is_self
                        this.is_focus = !this.is_self
                        if (this.is_self) {
                            this.$store.commit('changeIsSelf')
                            allEmptyText = {
                                isHaveBookComment:'还没有短书评，收货后评论或者直接在图书商品发表吧。',
                                isHaveLongBookComment:'还没有长书评，图书商品页面可以发表哦。',
                                isHaveBookList:'还没有书单，快去写一个。'
                            }
                            resolve(allEmptyText)
                        }
                        if (!this.info.hasOwnProperty('gender')) {
                            this.info.gender = 0
                        }
                        if (this.info.gender && this.info.gender == 1) {
                            this.$store.commit('changeTA')
                        }
                        if (data.followInfo.errorCode == 0) {
                            this.followInfo = data.followInfo
                            this.isFollow = this.followInfo.data.is_follow
                        } else {
                            this.errobj = {
                                type: 'pop',
                                errorMsg: data.followInfo.errorMsg
                            }
                        }

                        if (data.data.desc && data.data.desc.gblen() > 36) {
                            this.isTextLeft = true
                            this.isOpen = true
                        }
                    } else if (data.errorCode == 96) {
                        // window.location.href = login_url
                    } else {
                        this.errobj = {
                            type: 'pop',
                            errorMsg: data.errorMsg
                        }
                    }
                    reject(allEmptyText)
                }).catch((e) => {
                    reject(allEmptyText)
                    this.errobj = {
                        type: 'pop',
                        errorMsg: '网络错误请稍后重试'
                    }
                })
            })
        }
        getInfo.call(this).then(res => {
            this.allEmptyText = res
        }).catch(res => {
            this.allEmptyText = res
        }).finally(() => {
            //出书
            this.$http({
                method: 'post',
                url: 'my.php',
                data: {
                  action: 'my_book_list',
                  page: 1,
                  page_size: 2
                }
            }).then((result) => {

                var data = result.data;
                if(data.errorCode == 0 && data.data && data.data.result){
                    this.bookInfoList = data.data.result;
                    this.isHaveBookInfo = this.bookInfoList.length > 0? true : false
                    this.myBookListUrl = 'http://writebookapi.dangdang.com/h5-myupload?customerid=' + this.info.cust_id + '&tab=' + (this.isHaveBookInfo ? '0':'1');
                }

            }).catch((e) => {
                this.errobj = {
                    type: 'pop',
                    errorMsg: '网络错误请稍后重试'
                }
            })

            //书评
            this.$http({
                method: 'post',
                url: 'my.php',
                data: {
                    action: 'book_review_list',
                    page: 1,
                    page_size: 3,
                    image_size: 's'
                }
            }).then((result) => {
                var data = result.data;
                if (data.errorCode == 0) {
                    this.commentList = data;
                    this.isHaveBookComment = ''
                } else {
                    this.isHaveBookComment = this.allEmptyText.isHaveBookComment 
                }
            }).catch((e) => {
                this.isHaveBookComment = this.allEmptyText.isHaveBookComment
                this.errobj = {
                    type: 'pop',
                    errorMsg: '网络错误请稍后重试'
                }
            })           
             //长书评
            this.$http({
                method: 'post',
                url: 'my.php',
                data: {
                    action: 'long_review_list',
                    page: 1,
                    page_size: 3,
                    image_size: 's'
                }
            }).then((result) => {
                var data = result.data;
                if (data.errorCode == 0) {
                    this.commentLongList = data;
                    this.isHaveLongBookComment = ''
                } else {
                    this.isHaveLongBookComment = this.allEmptyText.isHaveLongBookComment 
                }
            }).catch((e) => {
                this.isHaveLongBookComment = this.allEmptyText.isHaveLongBookComment
                this.errobj = {
                    type: 'pop',
                    errorMsg: '网络错误请稍后重试'
                }
            })
            //书单
            this.$http({
                method: 'post',
                url: 'my.php',
                data: {
                    action: 'book_list',
                    page: 1,
                    page_size: 3
                }
            }).then((result) => {
                var data = result.data;
                if (data.errorCode == 0 && data.data) {
                    this.bookList = data.data
                    this.isHaveBookList = ''
                } else {
                    this.isHaveBookList = this.allEmptyText.isHaveBookList
                }
                this.isComplete = true
            }).catch(() => {
                this.isHaveBookList =this.allEmptyText.isHaveBookList
                this.errobj = {
                    type: 'pop',
                    errorMsg: '网络错误请稍后重试'
                }
                this.isComplete = true
            })
        })


    }
}
</script>
<style lang="stylus">
    @import '../common/stylus/omit.styl'
    @import '../common/stylus/userIcon.styl'
    .personl_bg
        width:1rem
        height:1rem
        position:absolute
        top:50%
        margin-top:-.5rem
        left:0.25rem
    .book_comment_button
        display:block
        width:5rem
        height:1.65rem
        border:1px solid #ff8161
        color:#ff8161
        font-size:0.65rem
        text-align:center
        line-height:1.65rem
        margin:0 auto
        border-radius:1rem
    .home
        color:#fff
        background:#f5f5f5
        position:relative
        .profile_bg
            position:absolute
            width:100%
            left:0
            top:2.2rem
            z-index:1
        .profile
            width:100%
            background-size:100% 100%
            padding-top:0.5rem
            padding-bottom:1rem
            text-align:center
            position:relative
            z-index:2
            text-shadow:1px 1px 1px rgba(0,0,0,0.5)
            .headimg
                width:4.3rem
                height:4.3rem
                border-radius:50%
                margin:0 auto
                border:0.15rem solid #0f0f0f;
                border-color:rgba(15, 15, 15,0.15)
                img
                    width:100%
                    height:100%
                    border-radius:50%
            .user_name
                text-align:center
                div  
                    position:relative
                    font-size:0.75rem
                    display:inline-block
                    img
                        width 0.7rem
                        height 0.7rem
                        position:absolute
                        right:-1.1rem
                        top:50%
                        margin-top:-.4rem
                    .user_home
                        position:absolute
                        top:50%
                        margin-top:-.5rem
                        right:-4.3rem
                    .user_link
                        width:2.8rem
                        height:auto
                        border-radius:0

            .follow
                text-align:center
                font-size:0.65rem
                span
                    display:inline-block
                    width:1px
                    height:0.8rem
                    background:#fff
                    margin-top:2px;
                    vertical-align:bottom
                    
            .introduce
                padding:0 0.75rem
                font-size:0.6rem
                margin-top:0.4rem
                position:relative
                text-align:center
                p
                    display:inline-block
                    width:95%
                    word-break:break-all
                .textLeft
                     text-align:left
            .edit
                display:inline-block
                padding:.125rem .45rem
                padding-bottom:.165rem
                margin:0 auto
                background:rgba(0,0,0,0.15)
                font-size:.6rem
                position:relative
                border-radius:.8rem
                .edit_icon
                    display:inline-block
                    width:0.55rem
                    height:0.625rem
                    background:url('../assets/images/edit2.png') no-repeat
                    background-size:100% 100%
                    margin-top:-1px
                    vertical-align:middle
        .profile_nobg
            background:linear-gradient(to bottom, #d02529, #fa4840)
        .follow_button
            position:relative
            width:100%
            height:2.25rem
            text-align:center
            color:#ffae00
            font-size:0.7rem
            line-height:2.25rem
            border-bottom:1px solid #e6e6e6
            background:#fff
            .no_concern
                img
                    width:0.775rem
                    height:0.6rem
                span
                    vertical-align:middle
            .aleady_concernd
                color:#646464
        .contact
            padding:0 0.5rem
            background:#fff
            position:relative
            z-index:2
            li
                height:2.25rem
                position:relative
                border-bottom:1px solid #f5f5f5
                font-size:0.7rem
                color:#969696
                line-height:2.25rem
                &:last-child
                    border:none
                .email_bg
                    @extend .personl_bg
                    background:url('../assets/images/email.png') no-repeat
                    background-size:100% 100%
                .wechat_bg
                    @extend .personl_bg;
                    background:url('../assets/images/wechat.png') no-repeat
                    background-size:100% 100%
                .qq_bg
                    @extend .personl_bg;
                    background:url('../assets/images/qq_gray.png') no-repeat
                    background-size:100% 100%
                p
                    margin-left:1.7rem
        .book_info
            padding:0.75rem
            background:#fff
            color:#323232
            position:relative
            z-index:2
            margin-top:.4rem
            .title
                font-size:.7rem
                color:#323232
                line-height:1.2rem
            .book_info_btn
                display:flex
                justify-content: center
                align-items: center
                padding: .8rem 0
                .info_btn
                    &:last-child
                        margin-right: 0

                    margin-right: 1rem
                    display: inline-block
                    width: 4.6rem
                    height: 1.6rem
                    line-height: 1.6rem
                    text-align: center
                    border: 1px solid #fc4843
                    border-radius: .2rem
                    color: #fc4843
                    font-size: .6rem
        .book_comment
            padding:0.75rem
            padding-bottom:1.25rem
            background:#fff
            color:#323232
            position:relative
            z-index:2
            margin-top:.4rem
            &:after
                content:''
                display:block
                width:100%
                height:0.4rem
                background:#f5f5f5
                position:absolute
                left:0
                top:-.4rem
            h2
                font-size:0.75rem
                // margin-top:1em
            .book_comment_contain
                margin-top:.6rem
                .comment_text
                    width:100%
                    .comment_text_p
                        omit-line(3)
        .book_list
            margin-top:0.4rem
            padding:0.75rem
            padding-bottom:1.25rem
            background:#fff
            color:#323232 
            h2
                font-size:0.75rem  
            .book_list_contain
                margin-top:.9rem
                padding:0
        .no_comment
            height:4rem
            font-size:.65rem
            color:#c8c8c8
            text-align:center
            line-height:1rem
            padding:2rem 3rem 0 3rem
        .send_email    
            height:2.2rem
            font-size:0.6rem
            text-align:center
            padding:0.75rem
            color:#969696


</style>


// WEBPACK FOOTER //
// homepage.vue?5d918149